import { useDispatch } from 'react-redux';
import { Fragment, useState } from "react";
import { format } from "date-fns";
import { motion } from "framer-motion"

import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import { setCurrentNavigation } from "../../slices/navigationSlice";
import useMount from '../../hooks/useMount';
import { dataValidator } from "../../tools/dataValidator";
import warrantyApi from "../../api/warrantyApi";
import useLog from '../../hooks/useLog';

import { getLabel } from "../../tools/Dictionary";

import { BsUpcScan } from "react-icons/bs";
import { BsTagFill } from "react-icons/bs";

import "./Warranty.css";

const WarrantyPage = (props) =>
{
  //Logs
  const { logPageView, logUserAction } = useLog();

  //Redux
  const Dispatch = useDispatch();

  //State
  const [form, setForm] = useState({
    serial: ""
  });
  const [error, setError] = useState({
    serial: ""
  });
  const [warranty, setWarranty] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  useMount(() =>
  {
    logPageView("Warranty");
    Dispatch(setCurrentNavigation("Warranty"));
  }, []);


  const onChangeSerial = (e) =>
  {

    let serial = e.target.value;
    

    onValidateField("serial", serial);

    setForm(form => ({
      ...form,
      serial
    }));

  };

  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity


    currentField = "serial";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:100"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }


    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };

  const onPressKey = (e) =>
  {
    if (e.key === "Enter")
    {
      onClickSearch();
    }
  }


  const toTitleCase = (_text) => {

    return _text
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  };


  const onClickSearch = async () =>
  {

    if (!onValidateField())
    {
      return;
    }

    try
    {

      setLoading(true);
      setWarranty(undefined);

      const warrantyData = await warrantyApi.getWarrantyBySerialNumber(form.serial);

      if (warrantyData.Success)
      {

        if (warrantyData.Data)
        {

          let formatWarranty = warrantyData.Data;

          formatWarranty.firstName = formatWarranty.firstName ? toTitleCase(formatWarranty.firstName) : "-";
          formatWarranty.lastName = formatWarranty.lastName ? toTitleCase(formatWarranty.lastName) : "-";
          formatWarranty.lastName = formatWarranty.lastName ? toTitleCase(formatWarranty.lastName) : "-";
          formatWarranty.address = formatWarranty.address ? toTitleCase(formatWarranty.address) : "-";
          formatWarranty.city = formatWarranty.city ? toTitleCase(formatWarranty.city) : "-";
          formatWarranty.expiration = format(formatWarranty.expiration, 'yyyy-MM-dd')

          logUserAction("Warranty search", { search: form.serial, result: formatWarranty });

          setWarranty(formatWarranty);

        }else{

          logUserAction("Warranty search", { search: form.serial, error: "not found" });

          setAlert({
            Title: getLabel("App", "Error"),
            Message: getLabel("Warranty", "Warranty information is unavailable for the entered serial number."),
            Confirm: getLabel("App", "Ok"),
            onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
            Display: true
          });

        }


      } else
        throw new Error(warrantyData.Error?.label || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."));

      setLoading(false);



    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  }


  return (
    <div className="page_cont" style={{marginBottom: "20px"}}>
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      <motion.div className="page_title" style={{textDecoration: "underline", color: "black"}}
        variants={{ hidden: { opacity: 0, scale: 0.95 }, show: { opacity: 1, scale: 1 } }}
        initial="hidden"
        animate="show"
      >
        {getLabel("Warranty", "Consult warranty information")}
      </motion.div>
      <motion.div className="warranty_body_row" 
        variants={{ hidden: { opacity: 0, scale: 0.95 }, show: { opacity: 1, scale: 1 } }}
        initial="hidden"
        animate="show"
      >
        <div className="warranty_body_col_title">
          {getLabel("Warranty", "Enter the serial number of your product")}
        </div>
        <div className="warranty_body_col_value">
          <input
            className="page_text_input"
            type="text"
            onChange={onChangeSerial}
            value={form.serial || ""}
            disabled={loading}
            autoFocus
            onKeyUp={onPressKey}
            style={{ textAlign: "center" }}
          />

          {error["serial"] &&
            <div className="page_modal_body_col_extra page_modal_body_col_error" style={{minHeight: "16px"}}>
              {error["serial"] || ""}
            </div>
          }
        </div>
      </motion.div>
      <motion.div className="warranty_body_row" style={{ marginTop: "0px" }}
        variants={{ hidden: { opacity: 0, scale: 0.95 }, show: { opacity: 1, scale: 1 } }}
        initial="hidden"
        animate="show"
      >
        {loading ? (
          <div className="troubleshoot_searching">
            {getLabel("Warranty", "Searching")}<span>.</span><span>.</span><span>.</span>
          </div>
        ) : (
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("Warranty", "Search")}
            style={{ maxWidth: "200px"}}
            onClick={onClickSearch}
            disabled={loading}
          />
        )}

      </motion.div>
      {warranty &&
      <motion.div className='warranty_result_cont'
        variants={{ hidden: { opacity: 0, y: -10 }, show: { opacity: 1, y: 0 } }}
        initial="hidden"
        animate="show"
      >
          <div className='warranty_result_cont_row_title'>
            {getLabel("Warranty", "First name")}
          </div>
          <div className='warranty_result_cont_row_value'>
            {warranty.firstName}
          </div>

          <div className='warranty_result_cont_row_title'>
            {getLabel("Warranty", "Last name")}
          </div>
          <div className='warranty_result_cont_row_value'>
            {warranty.lastName}
          </div>

          <div className='warranty_result_cont_row_title'>
            {getLabel("Warranty", "Address")}
          </div>
          <div className='warranty_result_cont_row_value'>
            {warranty.address}
          </div>
          <div className='warranty_result_cont_row_value'>
            {warranty.city}, {warranty.province || "-"}, {warranty.postalCode || "-"}
          </div>

          <div className='warranty_result_cont_row_title'>
            {getLabel("Warranty", "Phone")}
          </div>
          <div className='warranty_result_cont_row_value'>
            {warranty.phone || "-"}
          </div>

          <div className='warranty_result_cont_row_title'>
            {getLabel("Warranty", "Indoor unit(s)")}
          </div>
          {warranty.serialNumberInterior.length == 0 ? (
            <div className='warranty_result_cont_row_value'>  
              -
            </div>
          ):(
            <Fragment >
              {warranty.serialNumberInterior.map((s, index) => (
                <div className="warranty_result_cont_row_group" key={index}>
                  <div className='warranty_result_cont_row_value'>
                    <div className='warranty_result_cont_row_icon' title={getLabel("Warranty", "Serial number")}>
                      <BsUpcScan />
                    </div>
                    {s.serialNumber || "-"}
                  </div>
                  <div className='warranty_result_cont_row_value'>
                    <div className='warranty_result_cont_row_icon' title={getLabel("Warranty", "Model")}>
                      <BsTagFill />
                    </div>
                    {s.productCode || "-"}
                  </div>
                </div>
              ))}
            </Fragment>
          )}


          <div className='warranty_result_cont_row_title'>
            {getLabel("Warranty", "Outdoor unit(s)")}
          </div>
          {warranty.serialNumberExterior.length == 0 ? (
            <div className='warranty_result_cont_row_value'>
              -
            </div>
          ):(
            <Fragment >
              {warranty.serialNumberExterior.map((s, index) => (
                <div className="warranty_result_cont_row_group" key={index}>
                  <div className='warranty_result_cont_row_value'>
                    <div className='warranty_result_cont_row_icon' title={getLabel("Warranty", "Serial number")}>
                      <BsUpcScan />
                    </div>
                    {s.serialNumber || "-"}
                  </div>
                  <div className='warranty_result_cont_row_value'>
                    <div className='warranty_result_cont_row_icon' title={getLabel("Warranty", "Model")}>
                      <BsTagFill />
                    </div>
                    {s.productCode || "-"}
                  </div>
                </div>
              ))}
            </Fragment>
          )}

          <div className='warranty_result_cont_row_title'>
            {getLabel("Warranty", "Warranty")}
          </div>
          <div className='warranty_result_cont_row_value'>
            {warranty.duration} {getLabel("Warranty", "Year(s) extended, part and labour")}
          </div>
          
          <div className='warranty_result_cont_row_title'>
            {getLabel("Warranty", "Expiration")}
          </div>
          <div className='warranty_result_cont_row_value'>
            {warranty.expiration}
          </div>
        </motion.div>
      }
    </div>
  )

};

export default WarrantyPage;